// フォームの文字数カウンター（shared/form/_field の counter:）
// data-form-counter-for に入力欄の ID、data-form-counter-max に最大文字数を持つ要素を n/max に更新する。
// document へのイベント委譲なので、Turbolinks の画面遷移や <template> から複製した要素にも追加の初期化なしで効く。
// 初期値はサーバーで描画する。

(function () {
  'use strict';

  function updateCounter(input) {
    if (!input.id) return;

    var selector = '[data-form-counter-for="' + CSS.escape(input.id) + '"]';
    document.querySelectorAll(selector).forEach(function (counter) {
      var max = counter.dataset.formCounterMax;
      counter.textContent = input.value.length + '/' + max;
    });
  }

  document.addEventListener('input', function (event) {
    var target = event.target;
    if (!(target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement)) return;

    updateCounter(target);
  });
})();
